var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.09,
    height: 19.072,
    viewBox: "0 0 19.09 19.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-2",
    transform: "translate(-110.493 -254.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5,11.318A6.5,6.5,0,0,1,1.9.228a.75.75,0,0,1,1.06,1.06,4.99,4.99,0,1,0,7.07-.01.75.75,0,0,1,1.06-1.06,6.518,6.518,0,0,1,0,9.2A6.432,6.432,0,0,1,6.5,11.318Z",
    transform: "translate(110.493 262.182)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M10.99,11.733a.742.742,0,0,1-.53-.22.754.754,0,0,1,0-1.06,5.25,5.25,0,1,0-7.42,0,.75.75,0,1,1-1.06,1.06,6.749,6.749,0,1,1,9.55.01A.8.8,0,0,1,10.99,11.733Z",
    transform: "translate(116.08 254.428)",
    fill: "#061133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link-2.204d60a829883931394c657cdff974c1.svg";
export { ForwardRef as ReactComponent };